module.exports = __webpack_public_path__ + "static/media/Emotes-Thin.b5a9e8b7.png";